// Presentation only: preserve actual recipients and mentions inside the message.
export function stripLeadingMentions(html) {
  const doc = new DOMParser().parseFromString(html || '', 'text/html');
  const root = doc.body.firstElementChild?.tagName === 'P' ? doc.body.firstElementChild : doc.body;
  while (root.firstChild) {
    const node = root.firstChild;
    if (node.nodeType === 3) {
      const rest = node.textContent.replace(/^(?:\s*@[^\s@]+(?:@[^\s@]+)?(?=\s|$)\s*)+/, '').trimStart();
      if (rest) { node.textContent = rest; break; }
      node.remove();
    } else if (node.nodeType === 1 && (node.matches('a.mention, span.h-card') && (node.matches('a.mention') || node.querySelector('a.mention')))) {
      node.remove();
    } else {
      break;
    }
  }
  return doc.body.innerHTML;
}
